<p>Permission Management</p>
<select
    id="username"
    name="username"
    [(ngModel)]="selectedUsername"
    (ngModelChange)="getPermissionsForSelectedUser()"
    #username="ngModel">
        <option *ngFor="let u of players" [value]="u.username">
        {{ u.firstName }} {{ u.lastName }}
        </option>
</select>


<div *ngFor="let item of userPermissions">
  <label>
    <input
      type="checkbox"
      [(ngModel)]="item.isSelected"
      (change)="onSelectionChange(item)"
    />
    {{ item.permission }}
  </label>
</div>
